import { useMemo } from 'react';
import salesApi from '../sales.api';

/** Get a list of sales order status options for use in select component
 * Optionally pass a `currentId` to include a disabled option if it is currently selected
 */
export function useSalesOrderStatusOptions({ currentId }: { currentId?: number } = {}) {
    const query = salesApi.useSalesOrderStatusesQuery();
    const options = useMemo(() => {
        const opts = query.data
            ?.filter(o => o.isActive || o.id === currentId)
            .map(o => ({
                label: o.name,
                value: `${o.id}`,
                coreStatus: o.coreStatus,
                disabled: !o.isActive,
            }));
        return opts;
    }, [currentId, query.data]);

    return options;
}
